import React from 'react';
import FilterTable from './filterTable';

const DeviceFeaturesTable = (props) => {
  const featureTypesFilterValues = { all: '' };
  for (let key in props.featureTypes) {
    featureTypesFilterValues[props.featureTypes[key]] = props.featureTypes[key];
  }

  const columns = [
    {
      dataField: 'device.key',
      text: 'Device key',
      sort: true,
      filter_: { type: 'text' },
    },
    {
      dataField: 'feature.name',
      text: 'Name',
      sort: true,
      filter_: { type: 'text' },
    },
    {
      dataField: 'featureTypesStr',
      text: 'Type',
      sort: true,
      filter_: {
        type: 'select',
        values: featureTypesFilterValues,
      },
    },
    {
      dataField: 'registrationDateTime',
      text: 'Registration date and time',
      sort: true,
      filter_: {type: 'datetime'},
    },
    {
      dataField: 'expirationDate',
      text: 'Expiration date and time',
      sort: true,
      filter_: {type: 'datetime'},
    }
  ];

  const defaultSorted = [
    {
      dataField: 'registrationDateTime',
      order: 'desc'
    },
  ];

  let deviceFeatures = props.deviceFeatures.map(deviceFeature => {
    return { ...deviceFeature, featureTypesStr: props.featureTypes[deviceFeature.feature.type] };
  });

  return (
    <FilterTable
      {...props}
      objectName={'deviceFeatures'}
      data={deviceFeatures}
      columns={columns}
      noDataIndication="There are no device features"
      defaultSorted={defaultSorted}
    />
  );
}

export default DeviceFeaturesTable;


// WEBPACK FOOTER //
// ./src/components/deviceFeaturesTable.js